import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LabOrderService } from '../create/lab-order/lab-order.service';
// @ts-ignore
import * as pako from 'pako';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-doctor-service-report',
  templateUrl: './doctor-service-report.component.html',
  styleUrls: ['./doctor-service-report.component.scss'],
})
export class DoctorServiceReportComponent implements OnInit, AfterViewChecked {
  dsr?: SafeHtml;
  packingSlip?: SafeHtml;
  @ViewChild('packingSlipSection') packingSlipSection?: ElementRef<HTMLElement>;
  private packingSlipRotationApplied = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly labOrderService: LabOrderService,
    private readonly sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    const dsr = sessionStorage.getItem('dsr');
    const packingSlip = sessionStorage.getItem('packingSlip');
    if (dsr !== null) {
      this.dsr = this.getHtmlFromGzipEncodedString(dsr);
      sessionStorage.removeItem('dsr');
    }
    if (packingSlip !== null) {
      this.packingSlip = this.getHtmlFromGzipEncodedString(packingSlip);
      sessionStorage.removeItem('packingSlip');
    }
  }

  ngAfterViewChecked(): void {
    if (this.packingSlipRotationApplied || !this.packingSlipSection?.nativeElement) {
      return;
    }

    this.packingSlipRotationApplied = this.applyBarcodeRotation(this.packingSlipSection.nativeElement);
  }

  closeWindow() {
    window.close();
  }

  private getHtmlFromGzipEncodedString(encodedString: string): SafeHtml {
    const byteArr = new Uint8Array(
      window
        .atob(encodedString)
        .split('')
        .map(char => char.charCodeAt(0))
    );

    const unzippedBytes = pako.inflate(byteArr);

    const unzippedHtmlContent = new TextDecoder().decode(unzippedBytes);
    return this.sanitizer.bypassSecurityTrustHtml(unzippedHtmlContent);
  }

  private applyBarcodeRotation(container: HTMLElement): boolean {
    const image = container.querySelector<HTMLImageElement>('#image');
    const canvas = container.querySelector<HTMLCanvasElement>('#canvas');

    if (!image || !canvas || !canvas.getContext) {
      return false;
    }

    const render = () => {
      const context = canvas.getContext('2d');
      if (!context) {
        return;
      }

      canvas.width = image.height;
      canvas.height = image.width;
      context.translate(canvas.width, 0);
      context.rotate((90 * Math.PI) / 180);
      context.drawImage(image, 0, 0);
      image.style.visibility = 'hidden';
      image.style.position = 'absolute';
    };

    if (image.complete && image.naturalWidth > 0) {
      render();
      return true;
    }

    image.addEventListener(
      'load',
      () => {
        render();
      },
      { once: true }
    );

    return true;
  }
}
